var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition-group",
    { attrs: { name: _vm.transition, appear: "" } },
    [
      _vm.show && _vm.hasBackdrop
        ? _c("div", {
            key: "modal-backdrop",
            staticClass: "modal-backdrop fade show",
            style: { zIndex: _vm.baseZIndex + _vm.zIndex * 2 },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.show
        ? _c(
            "div",
            {
              key: "modal",
              staticClass: "modal fade show",
              class: { draggable: _vm.draggable, resizable: _vm.resizable },
              style: _vm.getStyle,
              attrs: {
                name: "modal",
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": "Modal",
                "aria-hidden": "true",
              },
              on: { click: _vm.closeBackdrop },
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-dialog",
                  class: _vm.getClass,
                  attrs: { role: "document" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "modal-content" },
                    [
                      _vm.needHeader
                        ? _c(
                            "div",
                            { ref: _vm.handleId, staticClass: "modal-header" },
                            [
                              _c("h5", { staticClass: "modal-title" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.modalTitle) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "modal-header-actions" },
                                [
                                  _vm._t("modal-header-actions"),
                                  _vm._v(" "),
                                  _vm.closeBtn
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "close text-midnight-blue opacity-100",
                                          attrs: {
                                            type: "button",
                                            "aria-label": "Close",
                                            "data-dismiss": "modal",
                                          },
                                          on: { click: _vm.close },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  staticClass:
                                                    "icon-close svg-inline--fa fa-times fa-w-13",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                    focusable: "false",
                                                    "data-prefix": "fas",
                                                    "data-icon": "times",
                                                    role: "img",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 320 512",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "currentColor",
                                                      d: "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "modal-body",
                          class: [
                            _vm.bodyClass,
                            {
                              "pt-sm-4 mt-sm-2": !_vm.needHeader,
                              "text-center": _vm.contentCentered,
                            },
                          ],
                        },
                        [_vm._t("default")],
                        2
                      ),
                      _vm._v(" "),
                      _vm._t("modal-footer", function () {
                        return [
                          _vm.needFooter
                            ? _c(
                                "div",
                                {
                                  staticClass: "modal-footer border-0",
                                  class: {
                                    "pt-0": !_vm.needHeader,
                                    "justify-content-center":
                                      _vm.contentCentered,
                                  },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-6 col-sm px-0",
                                        class: [
                                          _vm.saveButtonOptions.visible
                                            ? _vm.size == "small"
                                              ? "px-sm-2"
                                              : "px-sm-3"
                                            : "",
                                        ],
                                      },
                                      [
                                        _vm.saveButtonOptions.visible
                                          ? _c(
                                              "button",
                                              {
                                                class: {
                                                  ..._vm.saveButtonOptions
                                                    .btnClass,
                                                },
                                                attrs: { type: "button" },
                                                on: { click: _vm.save },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.saveButtonOptions
                                                          .title
                                                      )
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-6 col-sm px-0",
                                        class: [
                                          _vm.cancelButtonOptions.visible
                                            ? _vm.size == "small"
                                              ? "px-sm-2"
                                              : "px-sm-3"
                                            : "",
                                        ],
                                      },
                                      [
                                        _vm.cancelButtonOptions.visible
                                          ? _c(
                                              "button",
                                              {
                                                class: {
                                                  ..._vm.cancelButtonOptions
                                                    .btnClass,
                                                },
                                                attrs: {
                                                  type: "button",
                                                  "data-dismiss": "modal",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.close.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.cancelButtonOptions
                                                          .title
                                                      )
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }